export const mapColourEnrichmentsToSwatchesMap = ({ enrichments }) =>
  enrichments.reduce((acc, swatch) => {
    acc[swatch.facetValueId] = swatch.enrichment.hexColour;

    return acc;
  }, {});
